

/**
 * 1) отправка формы с помощью ajax
 * 2) валидация формы. параметры валидации задается следующим образом (в порядке приоритета от большего к меньшему)
 *  a) через объект options.fields[{name: имя поля, func: (this)=>{}}], где name - имя поля, а func - функция валидации этого поля, принимающая аргументом HTMLElement этого поля
 *  b) через атрибут указанный в options.validate_type_attribute, значение которого должно совпадать с одним из списка (email, phone, required, list)
 * 3) обработка результата с помощью передаваемой callback функции
 * 
 * @param {HTMLElement} element - DOM-элемент формы
 * @param {string} options.url 
 * @param {string} options.action
 * @param {string | HTMLElement} options.submit_btn - селектор или DOM элемент кнопки отправки формы. По умолчанию [type="submit"]
 * @param {string} options.validate_type_attribute - атрибут, содержащий значения типа 
 * @param {string} options.error_classname - css классы, которые будут присваиваться элементам ошибок
 * @param {function} options.callback_validate - функция срабатывает перед отправкой. 
 * @param {function} options.callback_success - функция обработки результата при успехе. 
 * @param {function} options.callback_error - функция обработки результата при провале. 
 * @param {function} options.fields - массив настроек для отдельных полей. 
 */
class Form {

    constructor(element, options) {

        this.exists = false

        let options_default = {
            url: null,
            action: null,
            setPreloader: null,
            submit_btn: '[type="submit"]',
            validate_type_attribute: 'data-type',
            error_classname: 'form-tooltip form-tooltip-top',
            callback_validate: null,
            callback_success: null,
            callback_error: null,
            fields: [
                {
                    name: '',
                    validate_function: null,
                    masked_function: null
                }
            ],
        }

        if (!element) {
            // console.error('Form: пустой DOM-элемент формы')
            return false
        }
        if (!options.url) {
            console.error('Form: не задан url')
            return false
        }
        if (!options) {
            console.error('Form: не заданы options')
            return false
        }
        if (!options.action) {
            console.error('Form: не задано действие action')
            return false
        }

        /* options */
        this.options = { ...options_default, ...options }

        /* element */
        this.element = element

        /* setPreloader */
        this.setPreloader = this.options.setPreloader || null

        /* submit_btn */
        this.submit_btn = null
        if (this.options.submit_btn) {
            if (typeof this.options.submit_btn !== 'string') {
                if (this.options.submit_btn instanceof HTMLElement) {
                    this.submit_btn = this.options.submit_btn
                } else {
                    console.info('Form: submit_btn не является объектом HTMLElement')
                    // return false
                }
            } else {
                this.submit_btn = this.element.querySelector(this.options.submit_btn)
                if (!this.submit_btn) {
                    console.info(`Form: не удалось найти submit_btn по селектору {this.options.submit_btn}`)
                    // return false
                }
            }
        } else {
            console.error(`Form: не задан options.submit_btn`)
            return false
        }

        /* popup */
        this.popup = window.popup || null

        /* fields */
        if (this.element.dataset.type) {
            this.options.action = this.element.dataset.type
        }

        let field_selectors = ['textarea', 'input[type="checkbox"]', 'input[type="radio"]', 'input[type="password"]', 'input[type="text"]', 'input[type="date"]', 'input[type="hidden"]', 'select']
        let field_elements = Array.from(this.element.querySelectorAll(field_selectors.join(', ')))
        this.fields = []
        this.addFields(field_elements)

        /* invalid_fields */
        this.invalid_fields = []

        /* event handlers */
        // submit
        if (this.element.tagName === 'FORM') {
            this.element.addEventListener('submit', (e) => {
                e.preventDefault()
                if (this.validation()) {
                    this.submit()
                }
            })
        } else {
            this.submit_btn.addEventListener('click', (e) => {
                if (this.validation()) {
                    this.submit()
                }
            })
        }

        // change
        this.element.addEventListener('change', (e) => {
            let field = this.getFieldByElement(e.target)
            if (!field) return false
            this.validation(field)
        })

        // если инициализация прошла успешно - переключаем exists на true
        this.exists = true
    }

    addFields(field_elements) {
        field_elements.forEach((field_element, index) => {

            let field = {}

            // элемент поля
            field.element = field_element

            // пропускаем элементы без name
            if (!field_element.name) return
            field.name = field_element.name.trim()

            // если элемент с таким-же атрибутом name присутствует - пропустить
            if (this.fields.findIndex(find_field => find_field.name === field.name) !== -1) {
                return
            }

            // ищем опции для поля
            field.validate_function = null
            field.masked_function = null
            let current_field_options = this.options.fields.find(filed_options => filed_options.name === field.name)
            if (current_field_options) {
                field.validate_function = current_field_options.validate_function
                field.masked_function = current_field_options.masked_function
            }

            // тип поля
            field.type = ''
            switch (field_element.tagName) {
                case 'TEXTAREA':
                    field.type = 'input'
                    break

                case 'INPUT':

                    switch (field_element.getAttribute('type')) {
                        case 'checkbox':
                            field.type = 'checkbox'
                            break

                        case 'radio':
                            field.type = 'radio'
                            break

                        default:
                            field.type = 'input'
                            break
                    }
                    break

                case 'SELECT':
                    field.type = 'select'
                    break
            }

            // тип валидации
            field.validate_type = field_element.getAttribute(this.options.validate_type_attribute)

            // обязательно ли к заполнению
            if (field_element.required || field.validate_type === 'required') {
                field.required = true
                field_element.removeAttribute('required')
            } else {
                field.required = false
            }

            // индекс поля
            field.index = index

            // маскирование
            if (typeof window.Inputmask !== 'undefined') {

                if (field.validate_type === 'phone') {

                    window.Inputmask({
                        "mask": '+7(999) 999-9999'
                    }).mask(field.element)
                }
            }

            this.fields.push(field)
        })
    }

    setFieldByName(name, key, value) {
        let find_field = this.fields.find(field => field.name === name)
        if (!find_field) {
            return
        }

        find_field[key] = value
    }

    checkEmpty(field) {
        let is_not_empty = true
        switch (field.type) {
            case 'input':
            case 'textarea':
                let value = field.element.value.trim()
                if (value === '') {
                    is_not_empty = false
                }
                break

            case 'checkbox':
                if (!field.element.checked) {
                    is_not_empty = false
                }
                break
        }

        return is_not_empty
    }

    showError(field, show = true) {

        // конкретно эта реализация добавляет элемент с текстом ошибки сразу за элементом поля.
        let error_element = null
        if (field.element.nextElementSibling && field.element.nextElementSibling.classList.contains(...this.options.error_classname.split(' '))) {
            error_element = field.element.nextElementSibling
        }

        if (show) {
            let error = (field.error) ? field.error : 'Ошибка'

            if (error_element) {
                error_element.innerHTML = error
            } else {
                error_element = document.createElement('span')
                this.options.error_classname.split(' ').forEach(classname => error_element.classList.add(classname))
                error_element.innerHTML = error
                field.element.after(error_element)
            }
        } else {
            if (error_element) {
                error_element.remove()
            }
        }
    }

    validation(fields = []) {

        let invalid_fields = []

        if (fields.length !== undefined && !fields.length) {
            fields = [...this.fields]
            this.refresh_all();

        } else {
            if (fields.length === undefined) {
                fields = [fields]
            }

            this.refresh(fields);
        }

        let is_valid_all = true;

        for (let field of fields) {

            let is_valid = true

            // проверяем на пустоту
            if (is_valid && field.required) {
                if (!this.checkEmpty(field)) {
                    field.error = 'Обязательно для заполнения!'
                    invalid_fields.push(field)
                    is_valid = false
                }
            }

            // если у поля задана функция валидации - используем ее
            if (is_valid && field.validate_function) {
                let exec_status = field.validate_function(field.element)
                if (exec_status) {
                    is_valid = field.validate_function(field.element)
                    invalid_fields.push(field)
                }

                // иначе валидируем согласно атрибуту validate_type_attribute
            } else if (is_valid && field.validate_type) {

                switch (field.validate_type) {

                    case 'email':
                        if (field.element.value.match(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/) === null) {
                            field.error = 'некорректный email!'
                            invalid_fields.push(field)
                            is_valid = false
                        }
                        break;

                    case 'phone':
                        if (field.element.value.length < 4 || field.element.value.match(/^[+0-9,. ()-]+$/) === null) {
                            field.error = 'некорректный номер!'
                            invalid_fields.push(field)
                            is_valid = false
                        }
                        break;
                }
            }

            if (!is_valid) is_valid_all = false
        }

        // проходимся по всем невалидным полям и показываем их ошибки
        invalid_fields.forEach(field => {
            this.showError(field, true)
        });

        this.invalid_fields = [...this.invalid_fields, ...invalid_fields]

        return is_valid_all;
    }

    validate(field=[]) {
        return this.validation(field)
    }

    getFieldValue(field) {
        let value = null

        switch (field.type) {
            case 'input':
            case 'textarea':
            case 'checkbox':
            case 'select':
                value = field.element.value.trim()
                break
        }

        return value
    }

    getFieldByElement(element) {
        let find_field = this.fields.find((field) => field.element === element)
        return find_field
    }

    refresh_all() {
        this.invalid_fields.forEach(field => {
            this.showError(field, false)
        });
        this.invalid_fields = [];
    }

    refresh(fields) {

        // клонируем, на случай, если передан this.invalid_fields
        let clone_arr = [...fields]

        clone_arr.forEach(field => {
            let find_index = this.invalid_fields.findIndex(invalid_field => invalid_field.index === field.index);
            this.showError(field, false)
            this.invalid_fields.splice(find_index, 1);

        });
    }

    submit() {
        let url = this.options.url

        if (!this.validation()) return false
        // если есть пользовательская функция валидации - применяем ее
        if (this.options.callback_validate) {
            if (!this.options.callback_validate(this)) {
                return false
            }
        }

        let body = new FormData
        this.fields.forEach(field => {
            let name = field.name
            let value = this.getFieldValue(field)
            if (name) {
                body.append(name, value)
            }
        })

        body.append('action', this.options.action)

        if (this.setPreloader) this.setPreloader(true)
        fetch(url, {
            method: 'POST',
            body
        })
            .then((response) => {
                console.log(response)
                if (response.status > 200) {
                    throw new Error(`${response.status}`)
                }
                return response.json()
            })
            .then((response) => {

                let title = ''
                let message = ''
                if (response.status) {
                    if (this.options.callback_success) {
                        this.options.callback_success(this.element, response)
                    }

                    title = (response.title) ? response.title : 'Успех'
                    message = (response.message) ? response.message : 'Форма успешно отправлена'

                } else {
                    if (this.options.callback_error) {
                        this.options.callback_error(this.element, response)
                    }
                    title = response.errors[0]['title'] || 'Ошибка'
                    message = response.errors[0]['message']
                }

                if (this.popup) {
                    this.popup.set({title, message})
                    this.popup.open()
                }
                if (this.setPreloader) this.setPreloader(false)
            })
            .catch(err => {
                if (this.setPreloader) this.setPreloader(false)
                if (this.popup) {
                    this.popup.set({title: 'Ошибка', message: err})
                    this.popup.open()
                }
                console.error(err)
            })
            .finally(()=>{
                if (this.element.reset) {
                    this.element.reset()
                }
            })
    }

    serialize() {
        let body = new FormData
        this.fields.forEach(field => {
            let name = field.name
            let value = this.getFieldValue(field)
            if (name) {
                body.append(name, value)
            }
        })

        return body
    }
}

export default Form